<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><image href="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNzQ4XzQ2NDQ5KSI+CiAgICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDFfNzQ4XzQ2NDQ5KSI+CiAgICAgIDxwYXRoCiAgICAgICAgZD0iTTMuMTI1IDBIMTMuMTI1TDE4LjEyNSA1VjE4Ljc1QzE4LjEyNSAxOS40NDA0IDE3LjU2NTQgMjAgMTYuODc1IDIwSDMuMTI1QzIuNDM0NjMgMjAgMS44NzUgMTkuNDQwNCAxLjg3NSAxOC43NVYxLjI1QzEuODc1IDAuNTU5NjI1IDIuNDM0NjMgMCAzLjEyNSAwWiIKICAgICAgICBmaWxsPSIjRkY3RDAwIiBzdHJva2U9InRyYW5zcGFyZW50IiAvPgogICAgICA8cGF0aCBkPSJNNSA3SDkiIHN0cm9rZT0iI0ZGRjdGNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KICAgICAgPHBhdGggZD0iTTUgMTFIMTQiIHN0cm9rZT0iI0ZGRjdGNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KICAgICAgPHBhdGggZD0iTTUgMTVIMTQiIHN0cm9rZT0iI0ZGRjdGNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KICAgICAgPHBhdGggZD0iTTEzLjEyNSAwTDE4LjEyNSA1SDE0LjM3NUMxMy42ODQ2IDUgMTMuMTI1IDQuNDQwMzcgMTMuMTI1IDMuNzVWMFoiIGZpbGw9IiNGRkNGOEIiIHN0cm9rZT0idHJhbnNwYXJlbnQiIC8+CiAgICA8L2c+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF83NDhfNDY0NDkiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIiAvPgogICAgPC9jbGlwUGF0aD4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDFfNzQ4XzQ2NDQ5Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K"></image></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconFileDocColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-file-doc-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
